// test699
(699 && 0);
